import React, { useEffect, useState } from "react";
import { Col, Nav, NavItem, NavLink, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import StatusViewEditComponent from "../../components/statusViewEditComponent";
import classnames from "classnames";
import { toast } from "react-toastify";
import DeleteModal from "../../../../../Components/Common/DeleteModal";

import {
  createProductStockStorageLocation,
  createProductStockStorageLocationSuccess,
  deleteProductStockStorageLocation,
  deleteProductStockStorageLocationSuccess,
  getProductStockStorageLocationList,
  updateProductStockStorageLocation,
  updateProductStockStorageLocationSuccess,
} from "../../../../../store/product/action";
export default function ProductStockStorageLocation() {
  const dispatch = useDispatch();
  const { productStockStorageLocationListSuccessAPI } = useSelector(
    (state) => ({
      productStockStorageLocationListSuccessAPI:
        state.ProductCrmIT.productStockStorageLocationListSuccess
          ?.productstockstoragelocation_list,
    })
  );

  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [statusFlag, setStatusFlag] = useState(false);
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    FlagActive: "0",
  });

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      // Task Status create
      dispatch(createProductStockStorageLocation([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = productStockStorageLocationListSuccessAPI?.sort(
        (a, b) => b.Id - a.Id
      );
    }

    setStatusList(data);
  }, [productStockStorageLocationListSuccessAPI, activeTab]);

  useEffect(() => {
    dispatch(getProductStockStorageLocationList());
  }, []);

  const Tabs = [
    {
      id: "1",
      name: "Location",
    },
  ];
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //  Task Status delete

      dispatch(deleteProductStockStorageLocation([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      FlagActive: updateItemStatus?.FlagActive,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        // Task Status update
        dispatch(updateProductStockStorageLocation([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  const {
    createProductStockStorageLocationSuccessAPI,
    updateProductStockStorageLocationSuccessAPI,
    deleteProductStockStorageLocationSuccessAPI,
  } = useSelector((state) => ({
    createProductStockStorageLocationSuccessAPI:
      state.ProductCrmIT.createProductStockStorageLocationSuccess,
    updateProductStockStorageLocationSuccessAPI:
      state.ProductCrmIT.updateProductStockStorageLocationSuccess,
    deleteProductStockStorageLocationSuccessAPI:
      state.ProductCrmIT.deleteProductStockStorageLocationSuccess,
  }));

  // Add New  response
  useEffect(() => {
    if (isEmpty(createProductStockStorageLocationSuccessAPI)) return;
    if (createProductStockStorageLocationSuccessAPI?.status === 200) {
      toast.success(createProductStockStorageLocationSuccessAPI?.message);
      dispatch(getProductStockStorageLocationList());
    } else {
      toast.error(createProductStockStorageLocationSuccessAPI?.message);
    }
    dispatch(createProductStockStorageLocationSuccess([]));
  }, [createProductStockStorageLocationSuccessAPI]);

  // Update  response
  useEffect(() => {
    if (isEmpty(updateProductStockStorageLocationSuccessAPI)) return;
    if (updateProductStockStorageLocationSuccessAPI?.status === 200) {
      toast.success(updateProductStockStorageLocationSuccessAPI?.message);
      dispatch(getProductStockStorageLocationList());
    } else {
      toast.error(updateProductStockStorageLocationSuccessAPI?.message);
    }
    dispatch(updateProductStockStorageLocationSuccess([]));
  }, [updateProductStockStorageLocationSuccessAPI]);
  // Delete  response
  useEffect(() => {
    if (isEmpty(deleteProductStockStorageLocationSuccessAPI)) return;
    if (deleteProductStockStorageLocationSuccessAPI?.status === 200) {
      toast.success(deleteProductStockStorageLocationSuccessAPI?.message);
      dispatch(getProductStockStorageLocationList());

      setDeleteModal(false);
    } else {
      toast.error(deleteProductStockStorageLocationSuccessAPI?.message);
    }
    dispatch(deleteProductStockStorageLocationSuccess([]));
  }, [deleteProductStockStorageLocationSuccessAPI]);

  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}
      <Row className="row align-items-end mt-3">

      </Row>
      <Row>
        <Col lg={12}>
          <StatusViewEditComponent
            statusList={statusList}
            setStatusList={setStatusList}
            createStatus={createStatus}
            setCreateStatus={setCreateStatus}
            handleCreateNewStatus={handleCreateNewStatus}
            setDeleteStatus={setDeleteStatus}
            setDeleteModal={setDeleteModal}
            setUpdateItemStatus={setUpdateItemStatus}
            statusFlag={statusFlag}
          />
        </Col>
      </Row>
    </>
  );
}
